/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExerciseAnswer,
    ExerciseAnswerFromJSON,
    ExerciseAnswerFromJSONTyped,
    ExerciseAnswerToJSON,
} from './';

/**
 * 
 * @export
 * @interface VideoExercisesAnswer
 */
export interface VideoExercisesAnswer {
    /**
     * 
     * @type {Array<ExerciseAnswer>}
     * @memberof VideoExercisesAnswer
     */
    exercises?: Array<ExerciseAnswer>;
}

export function VideoExercisesAnswerFromJSON(json: any): VideoExercisesAnswer {
    return VideoExercisesAnswerFromJSONTyped(json, false);
}

export function VideoExercisesAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideoExercisesAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exercises': !exists(json, 'exercises') ? undefined : ((json['exercises'] as Array<any>).map(ExerciseAnswerFromJSON)),
    };
}

export function VideoExercisesAnswerToJSON(value?: VideoExercisesAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exercises': value.exercises === undefined ? undefined : ((value.exercises as Array<any>).map(ExerciseAnswerToJSON)),
    };
}


